const e = "style-module__messageWrapper___d7N8T", t = "style-module__left___PPZ6E", _ = "style-module__message___TASrX", s = "style-module__right___g7B4U", o = "style-module__relativeWrapper___QBVhN", n = "style-module__relativeContainer___6Q8AB", r = "style-module__timestampContainer___Rpq1k", a = "style-module__show___QtMgW", l = "style-module__timestamp___11xjs", m = "style-module__senderContainer___q2ywe", i = "style-module__withExternalBody___yjC1J", d = "style-module__noExternalBody___rNrdb", y = {
  messageWrapper: e,
  left: t,
  message: _,
  right: s,
  relativeWrapper: o,
  relativeContainer: n,
  timestampContainer: r,
  show: a,
  timestamp: l,
  senderContainer: m,
  withExternalBody: i,
  noExternalBody: d
};
export {
  y as default,
  t as left,
  _ as message,
  e as messageWrapper,
  d as noExternalBody,
  n as relativeContainer,
  o as relativeWrapper,
  s as right,
  m as senderContainer,
  a as show,
  l as timestamp,
  r as timestampContainer,
  i as withExternalBody
};
